import React from "react";
import "./Departments.css";

const PashusamvardhanVibhag = () => {
  return (
    <div className="dept-page">

      {/* TOP STRIP */}
      <div className="dept-top-strip">
        <span>🏛 महाराष्ट्र शासन</span>
        <span>पशुसंवर्धन विभाग</span>
      </div>

      {/* HEADER */}
      <header className="dept-header">

        <div className="dept-header-emblem">
          🐄
        </div>

        <div className="dept-header-text">

          <div className="dept-header-org">
            जिल्हा परिषद विभाग
          </div>

          <h1 className="dept-header-title">
            पशुसंवर्धन विभाग
          </h1>

          <div className="dept-header-subtitle">
            पशुधन विकास व पशुवैद्यकीय सेवा
          </div>

        </div>

        <div className="dept-header-badge">
          ANIMAL HUSBANDRY
        </div>

      </header>

      {/* NAVIGATION */}
      <div className="dept-nav">

        <button className="dept-nav-tab active">
          विभाग माहिती
        </button>

        <button className="dept-nav-tab">
          तांत्रिक सेवा
        </button>

        <button className="dept-nav-tab">
          योजना
        </button>

        <button className="dept-nav-tab">
          संपर्क
        </button>

      </div>

      {/* MAIN */}
      <main className="dept-main">

        {/* INTRO */}
        <section className="dept-intro">

          <div className="dept-intro-label">
            पशुधन विकास व आरोग्य सेवा
          </div>

          <p className="dept-intro-text">
            <strong>पशुसंवर्धन विभाग</strong> हा पशुधनाच्या विकासासाठी आणि
            पशुपालकांच्या हितासाठी कार्यरत असून ग्रामीण व शहरी भागात
            रोजगारनिर्मितीमध्ये महत्त्वाची भूमिका बजावतो.
            दूध, मांस, अंडी व इतर पशुधन उत्पादनांमुळे राष्ट्रीय उत्पन्नात
            भर पडते. पशुधनाच्या आरोग्य संवर्धनासाठी कृत्रिम रेतन,
            लसीकरण, उपचार व पशुपालन प्रशिक्षण यांसारख्या सेवा
            विभागामार्फत पुरविल्या जातात.
          </p>

        </section>

        {/* STATS */}
        <section className="dept-stats">

          <div className="dept-stat-card">
            <div className="dept-stat-value">228</div>
            <div className="dept-stat-label">
              पशुवैद्यकीय दवाखाने
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">11.4L+</div>
            <div className="dept-stat-label">
              पशुधन संख्या
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">8.6L+</div>
            <div className="dept-stat-label">
              शेळ्या व मेंढ्या
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">24x7</div>
            <div className="dept-stat-label">
              पशुवैद्यकीय सेवा
            </div>
          </div>

        </section>

        {/* LEFT SECTION */}
        <div>

          {/* TECHNICAL SERVICES */}
          <section className="dept-section">

            <div className="dept-section-header">

              <div className="dept-section-icon">
                🩺
              </div>

              <h2 className="dept-section-title">
                तांत्रिक सेवा
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">

                <div className="scheme-card-name">
                  पशुवैद्यकीय उपचार
                </div>

                <div className="scheme-card-desc">
                  शासकीय पशुवैद्यकीय दवाखान्यांद्वारे पशुधनासाठी
                  आरोग्य तपासणी व उपचार सेवा पुरविल्या जातात.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  कृत्रिम रेतन सेवा
                </div>

                <div className="scheme-card-desc">
                  गायी व म्हशींना कृत्रिम रेतन करून
                  पशुधनाची गुणात्मक वाढ करण्यात येते.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  गर्भ व वंधत्व तपासणी
                </div>

                <div className="scheme-card-desc">
                  गर्भ तपासणी व वंधत्व तपासणीद्वारे
                  पशुपालकांच्या उत्पन्न वाढीस मदत केली जाते.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  मेंढी व शेळी उपचार
                </div>

                <div className="scheme-card-desc">
                  मेंढ्या, शेळ्या आणि कुक्कुट पक्ष्यांसाठी
                  उपचार व आरोग्य सेवा उपलब्ध आहेत.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  फिरते पशुचिकित्सा केंद्र
                </div>

                <div className="scheme-card-desc">
                  जिल्ह्यातील फिरत्या पशुचिकित्सा केंद्रांद्वारे
                  गावागावात सेवा पुरविल्या जातात.
                </div>

              </div>

            </div>

          </section>

          {/* VACCINATION */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                💉
              </div>

              <h2 className="dept-section-title">
                लसीकरण मोहीम
              </h2>

            </div>

            <div className="dept-highlight-box">

              <div className="dept-highlight-box-title">
                🐄 संसर्गजन्य रोग प्रतिबंध
              </div>

              <p>
                जनावरांमधील लाळ खुरकुत (FMD), फऱ्या (BQ),
                घटसर्प (H.S.), पी पी आर (PPR) व
                लम्पी स्कीन डिसीज (LSD) यांसारख्या रोगांवर
                प्रतिबंध करण्यासाठी नियमित लसीकरण मोहीम
                राबविली जाते.
              </p>

            </div>

          </section>

          {/* EXTENSION WORK */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                🌾
              </div>

              <h2 className="dept-section-title">
                विस्तार कार्य
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">

                <div className="scheme-card-name">
                  पशुपालन प्रशिक्षण
                </div>

                <div className="scheme-card-desc">
                  पशुपालन तंत्र, चारा व्यवस्थापन,
                  दुग्धव्यवसाय व मेंढीपालनावर प्रशिक्षण
                  शिबिरे आयोजित केली जातात.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  आधुनिक पशुपालन तंत्रज्ञान
                </div>

                <div className="scheme-card-desc">
                  शास्त्रीय दृष्टिकोनातून पशुपालनासाठी
                  आधुनिक तंत्रज्ञान व मार्गदर्शन पुरविले जाते.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  चारा विकास योजना
                </div>

                <div className="scheme-card-desc">
                  100% अनुदानावर सुधारित वैरण बियाणे
                  वाटप करून चारा व मुरघास निर्मितीस
                  प्रोत्साहन दिले जाते.
                </div>

              </div>

            </div>

          </section>

          {/* SCHEMES */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                📋
              </div>

              <h2 className="dept-section-title">
                पशुसंवर्धन विभागाच्या योजना
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">

                <div className="scheme-card-name">
                  दुधाळ जनावरांचा गट वाटप
                </div>

                <div className="scheme-card-desc">
                  अनुसूचित जाती / जमातीच्या लाभार्थींना
                  75% अनुदानावर 2 दुधाळ गायी / म्हशींचा गट वाटप.
                </div>

                <div className="scheme-card-amount">
                  ७५% अनुदान
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  शेळी गट वाटप योजना
                </div>

                <div className="scheme-card-desc">
                  10 शेळ्या व 1 बोकड यांचा शेळी गट
                  75% अनुदानावर उपलब्ध करून देण्यात येतो.
                </div>

                <div className="scheme-card-amount">
                  ऑनलाइन अर्ज
                </div>

              </div>

            </div>

          </section>

        </div>

        {/* SIDEBAR */}
        <aside className="dept-sidebar">

          {/* INFO */}
          <div className="dept-info-card">

            <div className="dept-info-card-title">
              विभाग माहिती
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                पशुवैद्यकीय दवाखाने
              </div>

              <div className="dept-info-val">
                228
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                पशुधन संख्या
              </div>

              <div className="dept-info-val">
                11,44,893
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                शेळ्या / मेंढ्या
              </div>

              <div className="dept-info-val">
                8,66,538
              </div>
            </div>

          </div>

          {/* CONTACT */}
          <div className="dept-contact-card">

            <div className="dept-contact-card-title">
              संपर्क माहिती
            </div>

            <div className="dept-contact-row">
              <span>🏢</span>
              <span>
                जिल्हा पशुसंवर्धन अधिकारी,
                जिल्हा परिषद, पुणे
              </span>
            </div>

            <div className="dept-contact-row">
              <span>📞</span>
              <span>(020) 26131799</span>
            </div>

          </div>

          {/* QUICK SERVICES */}
          <div className="dept-info-card">

            <div className="dept-info-card-title">
              प्रमुख सेवा
            </div>

            <div className="dept-services-grid">

              <div className="dept-service-item">
                उपचार सेवा
              </div>

              <div className="dept-service-item">
                कृत्रिम रेतन
              </div>

              <div className="dept-service-item">
                लसीकरण
              </div>

              <div className="dept-service-item">
                गर्भ तपासणी
              </div>

              <div className="dept-service-item">
                चारा मार्गदर्शन
              </div>

              <div className="dept-service-item">
                पशुपालन प्रशिक्षण
              </div>

            </div>

          </div>

        </aside>

      </main>

      {/* FOOTER */}
      <footer className="dept-footer">
        <strong>पशुसंवर्धन विभाग</strong>
        {" "}• जिल्हा परिषद प्रशासन
      </footer>

    </div>
  );
};

export default PashusamvardhanVibhag;